import 'arrive';
import $ from 'jquery';
import 'selectize/dist/js/standalone/selectize';

document.arrive('#newsletter-country-select', {existing: true}, function() {
    this.selectedIndex = -1;
    const selectizedCountryInput = $(this).selectize();
});
